import React from 'react';
import cx from 'classnames';
import '../../../ui/accordions/Accordion/index.js';
import '../../../ui/accordions/AccordionSelect/index.js';
import '../../../ui/badges/Badge/index.js';
import '../../../ui/badges/BadgeIcon/index.js';
import '../../../ui/badges/Checked/index.js';
import '../../../ui/badges/Panel/index.js';
import '../../../ui/badges/Status/index.js';
import '../../../ui/badges/Tag/index.js';
import '../../../ui/buttons/BabyButton/Base.js';
import '../../../ui/buttons/BabyButton/variants/Chat/index.js';
import '../../../ui/buttons/BabyButton/variants/Menu/index.js';
import '../../../ui/buttons/BabyButton/variants/User/index.js';
import '../../../ui/buttons/BabyButton/variants/Vip/index.js';
import '../../../ui/buttons/BabyButton/variants/Wallet/index.js';
import { Button } from '../../../ui/buttons/Button/index.js';
import '../../../ui/buttons/CloseButton/index.js';
import '../../../ui/buttons/DirectionButton/index.js';
import { GradientButton } from '../../../ui/buttons/GradientButton/index.js';
import '../../../ui/buttons/GradientButtonV2/index.js';
import '../../../ui/buttons/TabButton/index.js';
import '../../../ui/buttons/TabButtonV2/index.js';
import '../../../ui/buttons/TimerButton/index.js';
import '../../../ui/buttons/TimerButtonV2/index.js';
import '../../../ui/buttons/TimerButtonV3/index.js';
import '../../../ui/loaders/Loader/index.js';
import '../../../ui/loaders/ScreenLoader/index.js';
import { ModalComponent } from '../../../ui/modals/Modal/index.js';
import '../../../ui/popups/Popper/index.js';
import '../../../ui/popups/Popup/BasePopup/index.js';
import '../../../ui/popups/Popup/Thumb/index.js';
import { ThumbV2 } from '../../../ui/popups/Popup/ThumbV2/index.js';
import '../../../ui/popups/Popup/InfoTooltip/index.js';
import '../../../ui/sliders/EmblaCarousel/index.js';
import '../../../ui/tables/Table/index.js';
import '../../../ui/tables/Table/TableTd/index.js';
import '../../../ui/tabs/Tabs/index.js';
import '../../../ui/tabs/TabsV2/index.js';
import '../../../ui/texts/CryptoValue/index.js';
import '../../../ui/texts/AmountValue/index.js';
import '../../../ui/texts/TitleWithCurrency/index.js';
import '../../../ui/texts/Text/index.js';
import '../../../ui/texts/TextNavigation/index.js';
import '../../../ui/texts/MinValue/index.js';
import '../../../ui/socials/SocialsList/index.js';
import '../../../form/CheckBox/index.js';
import '../../../form/CodeInput/index.js';
import '../../../form/CryptoSelect/index.js';
import '../../../form/FileUploader/index.js';
import '../../../form/FormInput/index.js';
import '../../../form/FormSelect/index.js';
import '../../../form/PhoneInput/index.js';
import '../../../form/RadioButton/index.js';
import { Select } from '../../../form/Select/index.js';
import '../../../form/SelectV2/index.js';
import '../../../form/SelectV3/index.js';
import '../../../form/SelectV4/index.js';
import '../../../form/Search/Input/index.js';
import '../../../form/Search/NoResults/index.js';
import '../../../form/Switch/index.js';
import '../../../form/DatePickerInput/index.js';
import { useWindowSize } from '../../../../utils/hooks/useWindowSize.js';
import styles from './index.module.scss.js';

const PlayModal = ({
  isOpen,
  options = [],
  selectedID = [],
  onClose = () => {
  },
  onSelect = () => {
  },
  onRealPlayClick = () => {
  },
  onDemoPlayClick = () => {
  },
  afterOpenModal = () => {
  },
  onAfterClose = () => {
  },
  demoPlay,
  blockPageScroll = false,
  buttonFull = true,
  parentSelector,
  text = {
    title: "Balance in",
    realPlayButtonText: "Real Play",
    demoPlayButtonText: "Demo Play",
    selectPlaceholder: "Select"
  }
}) => {
  const { windowSize } = useWindowSize();
  return /* @__PURE__ */ React.createElement(
    ModalComponent.Modal,
    {
      modalIsOpen: isOpen,
      closeModal: () => onClose(),
      parentSelector,
      hideCloseButton: true,
      afterOpenModal,
      onAfterClose,
      blockPageScroll,
      configuration: {
        content: {
          height: windowSize.width < 800 ? "149px" : "165px",
          width: "auto",
          minWidth: 320,
          padding: windowSize.width < 800 ? 16 : 24,
          border: "1px solid #08333C"
        },
        childrenWrapper: {
          overflow: "unset",
          background: "transparent"
        }
      }
    },
    /* @__PURE__ */ React.createElement("div", { className: styles.box }, /* @__PURE__ */ React.createElement("div", { className: styles.row }, /* @__PURE__ */ React.createElement("div", { className: styles.col }, /* @__PURE__ */ React.createElement("div", { className: styles["select-wrapper"] }, /* @__PURE__ */ React.createElement("div", { className: styles.label }, text.title), /* @__PURE__ */ React.createElement(
      Select,
      {
        onSelect,
        options,
        selectedIds: selectedID,
        placeholder: text.selectPlaceholder,
        renderThumb: (thumbProps) => /* @__PURE__ */ React.createElement(
          ThumbV2,
          {
            image: thumbProps.image,
            thumbLabel: "",
            ...thumbProps
          }
        ),
        version: "v2",
        theme: "blue"
      }
    )))), /* @__PURE__ */ React.createElement(
      "div",
      {
        className: cx(styles.row, {
          [styles["button-full"]]: buttonFull
        })
      },
      /* @__PURE__ */ React.createElement("div", { className: styles.col }, /* @__PURE__ */ React.createElement(
        GradientButton,
        {
          kind: "fill",
          text: text?.realPlayButtonText,
          onClick: onRealPlayClick,
          animated: false
        }
      )),
      demoPlay && /* @__PURE__ */ React.createElement("div", { className: styles.col }, /* @__PURE__ */ React.createElement(
        Button,
        {
          size: "medium",
          onClick: onDemoPlayClick,
          themeKind: "dark-blue",
          text: text?.demoPlayButtonText,
          className: styles.demo
        }
      ))
    ))
  );
};
PlayModal.displayName = "PlayModal";

export { PlayModal };
//# sourceMappingURL=index.js.map
